import Api from '../api'
export default ({
  state: {
    itemMasterListsSite: [],
    itemMasterListsByGroupId: [],
    itemMasterListsBySubGroupId: [],
    ecommerceOrderLists: [],
    ecommerceOrderCompletedLists: [],
    ecommerceCancelledOrderList: [],
    ecommercePendingLists: [],
    ecommerceHoldLists: [],
    ecommerceInquiryLists: [],
    ecommerceOrderCancelledLists: []
  },
  mutations: {
    SET_ITEM_MASTER_LIST_SITE (state, itemMasterListSite) {
      state.itemMasterListsSite = itemMasterListSite
    },
    SET_ITEM_MASTER_LIST_GROUP_ID_SITE (state, itemMasterListByGroupId) {
      state.itemMasterListsByGroupId = itemMasterListByGroupId
    },
    SET_ITEM_MASTER_LIST_SUB_GROUP_ID_SITE (state, itemMasterListBySubGroupId) {
      state.itemMasterListsBySubGroupId = itemMasterListBySubGroupId
    },
    ECOMMERCE_ORDER_LIST(state, ecommerceOrderList) {
      state.ecommerceOrderLists = ecommerceOrderList
    },
    ECOMMERCE_INQUIRY_LIST(state, ecommerceInquiryList) {
      state.ecommerceInquiryLists = ecommerceInquiryList
    },
    ECOMMERCE_PENDING_ORDER_LIST(state, ecommercePendingList) {
      state.ecommercePendingLists = ecommercePendingList
    },
    ECOMMERCE_ORDER_COMPLETED_LIST(state, ecommerceCompletedOrderList) {
      state.ecommerceOrderCompletedLists = ecommerceCompletedOrderList
    },
    ECOMMERCE_ORDER_HOLD_LIST(state, ecommerceHoldList) {
      state.ecommerceHoldLists = ecommerceHoldList
    },
    ECOMMERCE_ORDER_CANCELLED_LIST(state, ecommerceCancelledOrderList) {
      state.ecommerceOrderCancelledLists = ecommerceCancelledOrderList
    },
    ECOMMERCE_ORDER_DETAIL(state, ecommerceOrderDetail) {
      state.ecommerceOrderDetails = ecommerceOrderDetail
    }
  },
  actions: {
    async loadItemMasterListForSite({commit}) {
      let response = await Api.request('get', '/item/itemListForSite/' + 33 + '', null)
      commit('SET_ITEM_MASTER_LIST_SITE', response.data.data)
        // // debugger
      return response
    },
    async loadItemMasterListByGroupIdForSite({commit}, id) {
      let response = await Api.request('get', '/ecommerce/itemListByCategoryList/' + id + '', null)
      commit('SET_ITEM_MASTER_LIST_GROUP_ID_SITE', response.data.data)
        // // debugger
      return response
    },
    async loadItemMasterListBySubGroupIdForSite({commit}, id) {
      let response = await Api.request('get', '/ecommerce/itemListBySubCategoryList/' + id + '', null)
      commit('SET_ITEM_MASTER_LIST_SUB_GROUP_ID_SITE', response.data.data)
        // // debugger
      return response
    },
    async loadItemMasterListFeatured({commit}) {
      let response = await Api.request('get', '/item/itemListByGroup/' + 33 + '/' + 'features' + '', null)
      commit('SET_ITEM_MASTER_LIST_SITE', response.data.data)
      return response
    },
    async loadItemMasterByItemId({commit}, id) {
      let response = await Api.request('get', '/item/itemMasterById/' + id + '', null)
      return response
    },
    async loadEcommerceOrderLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/ecommerceOrderListByType/' + this.state.organisationid + '/' + 'Processing' + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('ECOMMERCE_ORDER_LIST', responseValue)
      return response
    },
    async loadEcommerceInquiryLists({ commit }, date) {
      let response = await Api.request('get', '/ecommerce/ecommerceInquiryList/' + this.state.organisationid + '')
      let responseValue = response.data.data
      commit('ECOMMERCE_INQUIRY_LIST', responseValue)
      return response
    },
    async loadEcommercePendingOrderLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/ecommerceOrderListByType/' + this.state.organisationid + '/' + 'Confirmation' + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('ECOMMERCE_PENDING_ORDER_LIST', responseValue)
      return response
    },
    async loadEcommerceOrderCompletedLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/ecommerceOrderListByType/' + this.state.organisationid + '/' + 'Completed' + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('ECOMMERCE_ORDER_COMPLETED_LIST', responseValue)
      return response
    },
    async loadEcommerceOrderCancelledList({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/ecommerceOrderListByType/' + this.state.organisationid + '/' + 'Cancelled' + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('ECOMMERCE_ORDER_CANCELLED_LIST', responseValue)
      return response
    },
    async loadEcommerceOrderHoldLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/ecommerceOrderListByType/' + this.state.organisationid + '/' + 'Hold' + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('ECOMMERCE_ORDER_HOLD_LIST', responseValue)
      return response
    },
    async updateStatusOfdEcommerceOrder({commit}, data) {
      let response = await Api.request('put', '/ecommerce/updateStatusOfEcommerceOrder/' + data.inventoryHeaderId + '/' + this.getters.userId + '/' + data.statusType + '/' + data.reason)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadEcommerceOrderDetail({commit}, id) {
      let response = await Api.request('get', '/ecommerce/orderDetailListByOrderId/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('ECOMMERCE_ORDER_DETAIL', response.data.data)
      }
      return response
    },
    async ecommerceOrderDetails({commit}, id) {
      let response = await Api.request('get', '/ecommerce/orderDetailListByOrderId/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('ECOMMERCE_ORDER_DETAIL', response.data.data)
      }
      return response
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/website.js